import React, { useEffect, useState } from "react";
import Axios from "../../../services/AxiosInstance";
import { useNavigate } from 'react-router-dom';


const UpdateFeatureName = (props) => {

    const [updatefeatureName, setupdatefeatureName] = useState(props.featureName);
    const Navigate = useNavigate();

    const updateFeatureApi = () => {
        console.log(updatefeatureName, props.featureId);
        Axios
            .post(`api/bussiness/feature-edit-name?feature_id=${props.featureId}`, {
                feature_title: updatefeatureName,
            })
            .then((response) => {
                console.log(response);
                props.setIsFeatureNameUpdated(true);
            }).catch((error) => {
                alert(error.response.data.message);
            });
    }
    return (
        <>
            <div className="col-md-6 col-xl-3">
                <div className="card-box">
                    <div className="form-group mb-0 text-center">
                        <div className="form-group mb-3">
                            <label htmlFor="feature-name">Feature Name</label>
                            <input
                                onChange={(e) => setupdatefeatureName(e.target.value)}
                                id="feature-name"
                                value={updatefeatureName}
                                type="text"
                                className="form-control"
                                placeholder="Enter Feature Name"
                            />
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="form-group mb-0 text-center">
                            <button onClick={updateFeatureApi} className="btn btn-gradient btn-block" type="submit"> Update Feature Name </button>
                            <h3 onClick={() => props.setEditName(false)}>x</h3>
                        </div>

                    </div>  </div>
            </div>
        </>
    )
}

export default UpdateFeatureName;